import { useMemo } from 'react';

export const useText = (condition, text1, text2) =>
  useMemo(() => (condition ? text1 : text2), [condition, text1, text2]);
